window.tooltipModule = (() => {
  function initializeTooltips() {
    tippy(".tippy", {
      placement: "right",
      arrow: true,
      interactive: true,
      theme: "light",
      trigger: "click",
      animation: "scale",
    });
  }

  return {
    init: initializeTooltips,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  window.tooltipModule.init();
});
